export class User {
  givenName: string;
  username: string;
  email: string;
  phone: string;
  company: string;
}
